"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _helpers = require("composer-lib/lib/helpers");

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _reactRedux = require("react-redux");

var _conversations = require("composer-lib/redux/actions/conversations");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _composer = require("composer-lib/redux/actions/composer");

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _TitleEditor = _interopRequireDefault(require("composer-lib/components/composer/TitleEditor"));

var _actions = require("composer-lib/redux/actions");

var _conversationsHelpers = require("composer-lib/lib/helpers/conversationsHelpers");

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth,
    composerSettings: state.composerSettings,
    composition: state.composition,
    lock: state.lock,
    saveState: state.save
  };
};

var mapDispatchToProps = {
  hideAddConversationButton: _conversations.hideAddConversationButton,
  saveComposition: _composer.saveComposition,
  saveCompositionPending: _composer.saveCompositionPending,
  setBodyEditorActive: _actions.setBodyEditorActive,
  showAddConversationButton: _conversations.showAddConversationButton,
  updateTitleToSave: _composer.updateTitleToSave
};
var TitleEditorContainer = (0, _createReactClass.default)({
  displayName: "TitleEditorContainer",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    auth: _propTypes.default.object.isRequired,
    autoFocus: _propTypes.default.bool,
    className: _propTypes.default.string,
    composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default).isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    hideAddConversationButton: _propTypes.default.func.isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    maxLength: _propTypes.default.number,
    maxLengthWarningThreshold: _propTypes.default.number,
    required: _propTypes.default.bool.isRequired,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    setBodyEditorActive: _propTypes.default.func.isRequired,
    showAddConversationButton: _propTypes.default.func.isRequired,
    showLabel: _propTypes.default.bool.isRequired,
    showMaxLengthWarning: _propTypes.default.bool,
    tabIndex: _propTypes.default.string,
    updateTitleToSave: _propTypes.default.func.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      autoFocus: false,
      required: false,
      showLabel: false
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this.updateHelpers = (0, _helpers.makeComposerHelperUpdater)(this, [_helpers.ComposerHelperNames.SAVE_CHANGED_COMPOSITION, _helpers.ComposerHelperNames.DEBOUNCED_SAVE_CHANGED_COMPOSITION]);
    this.updateHelpers();
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var saveState = this.props.saveState;
    var nextSaveState = nextProps.saveState;
    this.updateHelpers(nextProps);

    if (nextSaveState.titleChanged && saveState.title !== nextSaveState.title) {
      this.debouncedSaveChangedComposition();
    }
  },
  toggleShowAddConversationButton: function toggleShowAddConversationButton(el) {
    (0, _conversationsHelpers.toggleTitleShowAddConversationButton)({
      el: el,
      hideAddConversationButton: this.props.hideAddConversationButton,
      saveState: this.props.saveState,
      showAddConversationButton: this.props.showAddConversationButton
    });
  },
  render: function render() {
    var _this$props = this.props,
        auth = _this$props.auth,
        autoFocus = _this$props.autoFocus,
        className = _this$props.className,
        composerSettings = _this$props.composerSettings,
        composition = _this$props.composition,
        lock = _this$props.lock,
        maxLength = _this$props.maxLength,
        maxLengthWarningThreshold = _this$props.maxLengthWarningThreshold,
        required = _this$props.required,
        saveState = _this$props.saveState,
        showLabel = _this$props.showLabel,
        showMaxLengthWarning = _this$props.showMaxLengthWarning,
        tabIndex = _this$props.tabIndex,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["auth", "autoFocus", "className", "composerSettings", "composition", "lock", "maxLength", "maxLengthWarningThreshold", "required", "saveState", "showLabel", "showMaxLengthWarning", "tabIndex"]);
    var locked = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);
    return _react.default.createElement(_TitleEditor.default, Object.assign({}, rest, {
      autoFocus: autoFocus,
      className: className,
      composerSettings: composerSettings,
      compositionTypeString: composition.typeString,
      hideAddConversationButton: this.props.hideAddConversationButton,
      highlighted: saveState.titleHighlighted,
      maxLength: maxLength,
      maxLengthWarningThreshold: maxLengthWarningThreshold,
      readOnly: locked || saveState.readOnly || composition.isReadOnly(),
      required: required,
      saveChangedComposition: this.saveChangedComposition,
      showAddConversationButton: this.props.showAddConversationButton,
      showLabel: showLabel,
      showMaxLengthWarning: showMaxLengthWarning,
      setBodyEditorActive: this.props.setBodyEditorActive,
      tabIndex: tabIndex,
      title: saveState.title,
      toggleShowAddConversationButton: this.toggleShowAddConversationButton,
      updateTitleToSave: this.props.updateTitleToSave
    }));
  }
});

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TitleEditorContainer);

exports.default = _default;
module.exports = exports.default;